<div class="menu-wrapper">
    <nav class="menu-nav">
        <ul class="menu-list">
            <div class="menu-list-wrapper" *ngFor="let item of navigationMenu">
                <li [routerLink]="[item.navPath]" routerLinkActive="active" class="menu-item" [id]="item?.navMenuId">
                    <span *ngIf="!this.checkRouterIsActive(item.navPath)">
                        <img class="menu-icon" alt="inactive-icons" [src]="item.iconInActivePath" />
                    </span>
                    <span *ngIf="this.checkRouterIsActive(item.navPath)">
                        <img class="menu-icon" alt="active-icons" [src]="item.iconActivePath" />
                    </span>
                    <span class="menu-name">{{item.menuName}}</span>
                </li>
            </div>
        </ul>
    </nav>
</div>